import { toast } from 'sonner';
import { ProductDetailsCard } from './products-details-card';
import { trpc } from '@web/lib/trpc';

type ProductDetailsViewProps = {
  productId: string;
  onClose?: () => void;
};

export function ProductDetailsView({
  productId,
  onClose,
}: ProductDetailsViewProps) {
  const { data: productDetailsData, refetch: refetchProductsData } =
    trpc.product.getDetails.useQuery({
      id: productId,
    });

  const { mutateAsync: updateProductMutation } =
    trpc.product.edit.useMutation();

  if (!productDetailsData) return null;

  return (
    <ProductDetailsCard
      product={productDetailsData}
      onClose={() => {
        void refetchProductsData();

        onClose?.();
      }}
      onSubmit={async (data) => {
        try {
          await updateProductMutation(data);
          toast.success('Product updated successfully');
        } catch (error) {
          toast.error('Failed to update product');
          console.error(error);
        }
      }}
    />
  );
}
